import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Spin,
  Tooltip,
  message,
} from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import AutoOpenSelect from '../SelectComponent/AutoOpenSelect';
import {
  fetchDieProfileDropdown,
  resetCurrentDieProfilePage,
  resetDieProfileData,
  resetDieProfileList,
} from './../../slices/die-profile';

import {
  resetCurrentDieSizePage,
  resetDieSizeList,
  fetchDieSizeDropdown,
} from './../../slices/die-size';
import {
  fetchVendorDropdown,
  resetCurrentVendorPage,
  resetVendorList,
} from '../../slices/vendor';
import {
  fetchBlosterDropdown,
  resetCurrentBlosterPage,
  resetBlosterList,
} from '../../slices/bolster';
import {
  fetchTransporterById,
  fetchTransporterDetails,
  updateTransporter,
} from './../../slices/transporter';
import {
  fetchDiePressDropdown,
  resetDiePressList,
  resetCurrentDiePressPage,
} from './../../slices/die-press';

import { createNumberValidationRule } from '../../utils/CreateNumberValidationRule';
import { debounce } from 'lodash';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
const { Option } = Select;

function EditTransporter() {
  const [form] = Form.useForm();
  let navigate = useNavigate();
  const { id } = useParams();
  const [dieType, setDieType] = useState(null);
  const [searchGroup, setSearchGroup] = useState('');
  const dispatch = useDispatch();
  const [btnLoading, setBtnLoading] = useState(false);
  const [selectedPress, setSelectedPress] = useState([]);
  const [selectedSize, setSelectedSize] = useState(null);
  const [searchDieProfile, setSearchDieProfile] = useState('');
  const [searchDieSize, setSearchDieSize] = useState('');
  const [searchDeveloper, setSearchDeveloper] = useState('');
  const [searchBloster, setSearchBloster] = useState('');
  const [showDropdownLoader, setShowDropdownLoader] = useState(false);
    const [isCheckboxDisabledActive, setIsCheckboxDisabledActive] = useState(false);
    const [forceOpen, setForceOpen] = useState(false);
  const [runUnderDeviation, setRunUnderDeviation] =
    useState('under development');
  const [runUnderDeviationReason, setRunUnderDeviationReason] = useState('');
  const {
    list: diePressList,
    list: diePressDropdown,
    loading: diePressLoading,
    currentpage: diePressCurrentPage,
    hasMore: diePressHasMore,
  } = useSelector(state => state.diePress);
  const [toolData, setToolData] = useState(); // Default value
  const [searchDiePress, setSearchDiePress] = useState('');
  const {
    list: dieProfileList,
    list: dieProfileDropdown,
    loading: dieProfileLoading,
    currentPage: dieProfileCurrentPage,
    hasMore: dieProfileHasMore,
  } = useSelector(state => state.dieProfile);
  const {
    list: dieSizeList,
    list: dieSizeDropdown,
    loading: dieSizeLoading,
    currentPage: dieSizeCurrentPage,
    hasMore: dieSizeHasMore,
  } = useSelector(state => state.diesize);

  const {
    list: developerList,
    list: vendorDropdown,
    loading: developerLoading,
    currentPage: developerCurrentPage,
    hasMore: developerHasMore,
  } = useSelector(state => state.vendor);
  const {
    list: blosterList,
    list: blosterDropdown,
    loading: blosterLoading,
    currentPage: blosterCurrentPage,
    hasMore: blosterHasMore,
  } = useSelector(state => state.bloster);
  const [isOrderDateRequired, setIsOrderDateRequired] = useState(false);
  const [isCheckboxDisabled, setIsCheckboxDisabled] = useState(false);
  const [isReceivedDateRequired, setIsReceivedDateRequired] = useState(false);
  const [selectedBalanceTypeOption, setSelectedBalanceTypeOption] = useState(null);
  const [selectSendSmsTypeOption, setSelectSendSmsTypeOption] = useState(null);
  const [selectIsActiveOption, setSelectIsActiveOption] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedVendor, setselectVendor] = useState(null);
  const [selectedBloster, setSelectBloster] = useState(null);
  const [selectedDiePress, setSelectDiePress] = useState(null);
  const [selectSemiHollowOption, setSelectSemiHollowOption] = useState(null);
  
  const sendingSmsType = [
    { id: 'sms', name: 'sms' },
    { id: 'whatsapp', name: 'whatsapp' },
    { id: 'email', name: 'email' },
  ];
  const isActiveStatus = [
    { id: 'active', name: 'active' },
    { id: 'inactive', name: 'inactive' },
   
  ];
  const balanceType = [
    { id: 'debit', name: 'debit' },
    { id: 'credit', name: 'credit' },
    
  ];


  const handleBalanceTypeOptionChange = value => {
    setSelectedBalanceTypeOption(value);
   
  };

  const handleSearchBalanceType = value => {
    setSelectedBalanceTypeOption(value);
  };

  const handleDeviationChange = e => {
    const value = e.target.value;
    setRunUnderDeviation(value);
    if (value !== 'inactive') {
      setRunUnderDeviationReason('');
    }
    // If "Active" is selected, make received_date required
    if (value === 'active') {
      setIsReceivedDateRequired(true);
    } else {
      setIsReceivedDateRequired(false);
      // If moving away from Active, clear received_date
      if (form.getFieldValue('received_date')) {
        form.setFieldsValue({ received_date: null });
      }
    }
    // If "Active" is selected and no received_date, optionally focus the field (UX improvement)
    if (value === 'active' && !form.getFieldValue('received_date')) {
      // Optionally focus the field
    }
  }

  const handleSendSmsTypeOptionChange = value => {
    if(value){
    setSelectSendSmsTypeOption(value);
    }else{
      setSelectSendSmsTypeOption(null);
    }
   
  };
  const handleIsActiveOptionChange = value => {
    if(value){
    setSelectIsActiveOption(value);
    }else{
      setSelectIsActiveOption(null);
    }
   
  };

  const handleSearchSmsType = value => {
    setSelectSendSmsTypeOption(value);
  };
  const handleSearchIsActive = value => {
    setSelectIsActiveOption(value);
  };


  const handleFormChange = changedValues => {
    if ('received_date' in changedValues) {
      const orderDate = changedValues.received_date;
      if (orderDate) {
        form.setFieldsValue({ is_active: true });
        setIsCheckboxDisabled(true); // Check the checkbox
      } else {
        form.setFieldsValue({ is_active: false }); // Enable the checkbox if order_date is cleared
        setIsCheckboxDisabled(false);
      }
    }
  
 
  };
  const debouncedSearchDieProfile = debounce((value, dispatch) => {
    dispatch(resetDieProfileData()); // Reset the list when searching
    dispatch(
      fetchDieProfileDropdown({
        page: 1,
        pagesize: 50,
        search: value || '',
      }),
    );
  }, 300);
  const handleSearchCity = value => {
    setSearchDieProfile(value);

    if (value) {
      debouncedSearchDieProfile(value, dispatch);
    } else {
      dispatch(resetDieProfileData());
      dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 50 }));
    }
  };
  const onScrollCity = event => {
    const target = event.target;

    if (
      !dieProfileLoading &&
      dieProfileHasMore &&
      target.scrollHeight - target.scrollTop - target.clientHeight < 50
    ) {
      const nextPage = dieProfileCurrentPage + 1;

      dispatch(
        fetchDieProfileDropdown({
          page: nextPage,
          pagesize: 50,
          search: searchDieProfile || '',
        }),
      );
    }
  };
  const handleSearchHSemiHollowDie = value => {
    setSelectSemiHollowOption(value);
  };
  const handleChangeDieSize = value => {
    setSearchDieSize(value);
    setSelectedSize(value);
  };
  const handleSearchDieSize = value => {
    setSearchDieSize(value);
    if (value) {
      setSearchDieSize(value);
      dispatch(fetchDieSizeDropdown({ page: 1, pagesize: 100 }));
    } else {
      setSearchDieSize('');
      dispatch(resetCurrentDieSizePage());
      dispatch(fetchDieSizeDropdown({ page: 1, pagesize: 10 }));
    }
  };
  const handleSearchDeveloper = value => {
    setSearchDeveloper(value);

    if (value) {
      setSearchDeveloper(value);
      dispatch(resetVendorList());
      dispatch(fetchVendorDropdown({ page: 1, pagesize: 100, search: value }));
    } else {
      setSearchDeveloper('');
      dispatch(resetVendorList());
      dispatch(resetCurrentVendorPage());
      dispatch(fetchVendorDropdown({ page: 1, pagesize: 10 }));
    }
  };
  const handleChangeDeveloper = value => {
    setselectVendor(value);
    setSearchDeveloper(value);
  };

  const handleSearchBloster = value => {
    setSearchBloster(value);

    if (value) {
      setSearchBloster(value);
      dispatch(resetBlosterList());
      dispatch(fetchBlosterDropdown({ page: 1, pagesize: 100, search: value }));
    } else {
      setSearchBloster('');
      dispatch(resetBlosterList());
      dispatch(resetCurrentBlosterPage());
      dispatch(fetchBlosterDropdown({ page: 1, pagesize: 10 }));
    }
  };
  const handleChangeBloster = value => {
    setSearchBloster(value);
    setSelectBloster(value);
  };
  useEffect(() => {
    const fetchTransporter = async () => {
      try {
        dispatch(fetchTransporterById(id))
          .unwrap()
          .then(response => {
          
            if (response.success) {
              const transporter = response.data;
           
             

              form.setFieldsValue({
                id: transporter?.id,
                party_name: transporter?.party_name,
                party_code: transporter?.party_code,
                opening_balance: transporter?.opening_balance,
                balance_type: transporter?.balance_type,
                is_cash_amount: transporter?.is_cash_amount,
                address: transporter?.address,
                city: transporter?.city,
                pincode: transporter?.pincode,
                mobile_no_sms: transporter?.mobile_no_sms,
                mobile_no: transporter?.mobile_no,
                phone_no: transporter?.phone_no,
                email_id: transporter?.email_id,
                send_sms_type: transporter?.send_sms_type,
                is_active: transporter?.is_active,
                // created_by: transporter?.created_by,
                // created_by_name: transporter?.created_by_name,
                // updated_by: transporter?.updated_by,
                // updated_by_name: transporter?.updated_by_name,
                // deleted_by: transporter?.deleted_by,
                // created_at: transporter?.created_at,
                // updated_at: transporter?.updated_at,
                // deleted_at: transporter?.deleted_at,
                // deleted: transporter?.deleted,
              });
              
       

            setSelectSendSmsTypeOption(transporter?.send_sms_type);
            setSelectedBalanceTypeOption(transporter?.balance_type);
            }
          })
          .catch(error => {
            console.error('');
          });
      } catch (error) {
        console.error('');
      }
    };

    fetchTransporter();
  }, [id, form]);

  const onScrollDieSize = async event => {
    const target = event.target;
    if (
      !dieSizeLoading &&
      dieSizeHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchDieSizeDropdown({ page: dieSizeCurrentPage, pagesize: 10 }));
    }
  };
  const onScrollDeveloper = async event => {
    const target = event.target;
    if (
      !developerLoading &&
      developerHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchVendorDropdown({ page: developerCurrentPage, pagesize: 10 }));
    }
  };

  const onScrollBloster = async event => {
    const target = event.target;
    if (
      !blosterLoading &&
      blosterHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchBlosterDropdown({ page: blosterCurrentPage, pagesize: 10 }));
    }
  };

  useEffect(() => {
    dispatch(resetDieProfileList());
    dispatch(resetDieSizeList());
    dispatch(resetVendorList());
    dispatch(resetBlosterList());
    dispatch(resetDiePressList());
    dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 50000 }));
    dispatch(fetchDieSizeDropdown({ page: 1, pagesize: 50000 }));
    dispatch(fetchVendorDropdown({ page: 1, pagesize: 50000 }));
    dispatch(fetchBlosterDropdown({ page: 1, pagesize: 50000 }));
    dispatch(fetchDiePressDropdown({ page: 1, pagesize: 50000 }));
  }, []);

  const handleReceivedDateChange = (date, dateString) => {
    form.setFieldsValue({ received_date: date });
    if (date) {
      setRunUnderDeviation('active');
      setIsReceivedDateRequired(true);
      form.setFieldsValue({ run_under_deviation: 'active', is_active: true });
    } else {
      setRunUnderDeviation('under development');
      setIsReceivedDateRequired(false);
      form.setFieldsValue({ run_under_deviation: 'under development', is_active: false });
    }
  };

  const handleOrderDateChange = (date, dateString) => {
    form.setFieldsValue({ order_date: date });
  };

  const handleFinish = values => {
    setBtnLoading(true);
    const formattedValues = {
      ...values,

 
    };
    values = formattedValues;

    dispatch(updateTransporter({ id: id, values }))
      .unwrap()
      .then(result => {
        setBtnLoading(false);
        if (result.success) {
          message.success('Transporter Updated Successfully!');
          navigate('/transporter-list');
        }
      })
      .catch(error => {
        setBtnLoading(false);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error); // Handle string error
        } else if (error instanceof Error) {
          message.error(error.message); // Handle Error object
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };


  return (
    <>
      <div className="sticyaction">
        <Row
          className="pagenamerow mb-0"
          justify="space-between"
          align="middle"
        >
          <Col>
            <h2 style={{ margin: 0 }}>Edit Transporter</h2>
            <div className="bredcrumbwrp">
              <Link onClick={() => navigate(-1)} className="back">
                <Back /> BACK
              </Link>
              <Breadcrumb
                items={[
                  { title: <Link to="/transporter-list">Transporter List</Link> },
                  { title: 'Edit Transporter' },
                ]}
              />
            </div>
          </Col>
        </Row>
      </div>
      <div className="formwrapper">
      <Form
          layout="vertical"
          onValuesChange={handleFormChange}
          form={form}
          initialValues={{
            is_active: true,
         
          }}
          onFinish={handleFinish}
          autoComplete="off"
        >
          <div className="formsection">
            <Row gutter={16}>
            <Col xs={12} sm={8} xl={6} xxl={3}>
                <Form.Item
                  label="Party Name"
                  name="party_name"
                  rules={[
                    { required: true, message: 'Please enter party name' },
                  ]}
                >
                  <Input placeholder="Enter Party Name"  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={3}>
                <Form.Item
                  label="Party Code"
                  name="party_code"
                  rules={[
                    { required: true, message: 'Please enter party code' },
                  ]}
                >
                  <Input placeholder="Enter Party Code"  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={3}>
                <Form.Item
                  label="Opening Balance"
                  name="opening_balance"
                  rules={[
                    { required: true, message: 'Please enter opening balance' },
                    {
                      pattern: /^\d*\.?\d*$/,
                      message: 'Please enter only digits & decimal.',
                    },
                    createNumberValidationRule({
                      allowNegative: false,
                      maxBeforeDecimal: 10, // Set max before decimal
                      maxAfterDecimal: 3, // Set max after decimal
                      allowDecimal: true,
                      allowZero: true,
                    }),
                  ]}
                >
                  <Input placeholder="Opening Balance" maxLength={15} />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={3}>
                  <Form.Item
                    name="balance_type"
                    label="Balance Type"
                    rules={[
                      {
                        required: true,
                        message: 'Please select a balance type',
                      },
                    ]}
                  >
                    <AutoOpenSelect
                      placeholder="Balance Type"
                      onChange={handleBalanceTypeOptionChange}
                      onSearch={handleSearchBalanceType}
                      showSearch={true}
                      value={selectedBalanceTypeOption}
                      allowClear
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {[
                        ...new Map(
                          balanceType.map(item => [item.id, item]),
                        ).values(),
                      ].map((el, index) => (
                        <Option key={el.id} value={el.id}>
                          {el.name}
                        </Option>
                      ))}
                    </AutoOpenSelect>
                  </Form.Item>
                </Col>
                   
              <Col xs={24} sm={12} xl={6} xxl={4}>
                <Form.Item
                  label=""
                  name="is_cash_amount"
                  valuePropName="checked"
                >
                  <Checkbox >Is This Cash Account</Checkbox>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={6} xxl={6}>
              <Form.Item label="Address" name="address">
            <Input.TextArea
              rows={3}
              placeholder="Enter Address"
              maxLength={100}
              onChange={e => {
                const value = e.target.value;
                const formattedValue = value
                  .toLowerCase()
                  .replace(/\b\w/g, char => char.toUpperCase());
                form.setFieldsValue({ address: formattedValue }); // Update Form state
              }}
            />
          </Form.Item>
          </Col>
              <Col xs={12} sm={8} xl={6} xxl={3}>
              
              <Form.Item
                  label="City"
                  name="city"
                  rules={[
                    { required: true, message: 'Please enter city' },
                  ]}
                >
                  <Input placeholder="Enter City"  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={3}>
                <Form.Item
                  label="Pincode"
                  name="pincode"
                  rules={[
                    { required: true, message: 'Please enter pincode' },
                    {
                        pattern: /^[0-9]{6}$/,
                        message: 'Pincode must be exactly 6 digits',
                      },
                  ]}
                >
                  <Input placeholder="Enter Pincode" />
                </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={4}>
              <Form.Item
                    label="Mobile Number (SMS)"
                    name="mobile_no_sms"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your phone number!',
                      },
                    ]}
                  >
                    <PhoneInput
                      country={'in'} // Default country (India)
                      enableSearch={true} // Enable searching for countries
                      placeholder="Enter mobile number"
                    />
                  </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={4}>
              <Form.Item
                    label="Mobile Number"
                    name="mobile_no"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your mobile number!',
                      },
                    ]}
                  >
                    <PhoneInput
                      country={'in'} // Default country (India)
                      enableSearch={true} // Enable searching for countries
                      placeholder="Enter mobile number"
                    />
                  </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={3}>
              <Form.Item
                    label="Phone Number"
                    name="phone_no"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your phone number!',
                      },
                    ]}
                  >
                    <PhoneInput
                      country={'in'} // Default country (India)
                      enableSearch={true} // Enable searching for countries
                      placeholder="Enter phone number"
                    />
                  </Form.Item>
              </Col>
              <Col xs={12} sm={8} xl={6} xxl={3}>
              <Form.Item
                    label="Email"
                    name="email_id"
                    rules={[
                      {
                        type: 'email',
                        message: 'Please enter a valid email address',
                      },
                    ]}
                  >
                    <Input placeholder="Enter Email" />
                  </Form.Item>
                  </Col>
                  <Col xs={12} sm={8} xl={6} xxl={3}>
                  <Form.Item
                    name="send_sms_type"
                    label="Sending Sms Type"
                    rules={[
                      {
                        required: true,
                        message: 'Please select sms type',
                      },
                    ]}
                  >
                    <AutoOpenSelect
                      placeholder="Sending Sms Type"
                      onChange={handleSendSmsTypeOptionChange}
                      onSearch={handleSearchSmsType}
                      showSearch={true}
                      value={selectSendSmsTypeOption}
                      allowClear
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {[
                        ...new Map(
                          sendingSmsType.map(item => [item.id, item]),
                        ).values(),
                      ].map((el, index) => (
                        <Option key={el.id} value={el.id}>
                          {el.name}
                        </Option>
                      ))}
                    </AutoOpenSelect>
                  </Form.Item>
                </Col>
                <Col xs={12} sm={8} xl={6} xxl={3}>
                  <Form.Item
                    name="is_active"
                    label="Is Active"
                    rules={[
                      {
                        required: true,
                        message: 'Please select sms type',
                      },
                    ]}
                  >
                    <AutoOpenSelect
                      placeholder="Is Active"
                      onChange={handleIsActiveOptionChange}
                      onSearch={handleSearchIsActive}
                      showSearch={true}
                      value={selectIsActiveOption}
                      allowClear
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {[
                        ...new Map(
                          isActiveStatus.map(item => [item.id, item]),
                        ).values(),
                      ].map((el, index) => (
                        <Option key={el.id} value={el.id}>
                          {el.name}
                        </Option>
                      ))}
                    </AutoOpenSelect>
                  </Form.Item>
                </Col>

           


            </Row>
          </div>
       
          <div className="flex justify-end">
            <Form.Item className="mb-0">
              <Button
                type="primary"
                htmlType="submit"
                loading={btnLoading}
                icon={<PlusOutlined />}
              >
                Edit Transporter
              </Button>
            </Form.Item>
          </div>
        </Form>
      </div>
    </>
  );
}

export default EditTransporter;
